import { useContext } from 'react'

import { faMapMarkerAlt } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import {
  Box, Button, DashboardModule, Form, Link, InputEnhanced,
} from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import { UseCampaignPayload } from '@hooks/useCampaign'
import useGeocode from '@hooks/useGeocode'

import Map from './components/Map'

interface PropertyLocationParams {
  campaignPayload: UseCampaignPayload,
}

const PropertyLocation = (props: PropertyLocationParams) => {
  const { campaignPayload } = props

  const {
    callbacks: {
      updateCampaign: updateFn,
    },
    campaign,
    updating,
  } = campaignPayload

  const pageContext = useContext(PageContext)
  const {
    callbacks: {
      geocodeAddress,
      updateCampaign,
    },
  } = pageContext

  const useGeocodePayload = useGeocode(campaign)

  const {
    address,
    callbacks: {
      geocodeAddress: geocodeAddressFn,
      setGeocodeState,
    },
    editing,
    isEnabled,
    latitude,
    loading,
    longitude,
    saveEnabled,
  } = useGeocodePayload

  const updateCampaignPayload = {
    callbacks: {
      action: updateFn,
      afterAction: () => setGeocodeState({ editing: false }),
    },
    entityParams: {
      id: campaign.id,
      latitude,
      longitude,
    },
    toastText: 'Property Location Updated',
  }

  const geocodeAddressPayload = {
    callbacks: {
      action: geocodeAddressFn,
    },
    toastText: 'Property Location Found',
  }

  return (
    <DashboardModule
      contentBoxProps={{ flexDirection: 'column' }}
      headerRight={!editing && (
        <Link
          onClick={() => setGeocodeState({ editing: true })}
          textProps={{ fontSize: 'small' }}
        >
          Manage
        </Link>
      )}
      title="Property Location"
    >
      <Form padding="large">
        {editing && (
          <Form.Field
            label="Property Address"
          >
            <Box flexDirection="row">
              <InputEnhanced
                keyPressCallbacks={[
                  {
                    eventKey: 'Enter',
                    callback: () => geocodeAddress(geocodeAddressPayload),
                  },
                ]}
                onChange={e => setGeocodeState({ address: e.target.value, geocodePerformed: false })}
                type="text"
                value={address}
              />

              <Button
                buttonStyle="primaryEdit"
                loading={loading}
                marginLeft="medium"
                maxWidth="25%"
                icon={<FontAwesomeIcon icon={faMapMarkerAlt} />}
                onClick={() => geocodeAddress(geocodeAddressPayload)}
                size="medium"
                width="fit-content"
              >
                Locate
              </Button>
            </Box>
          </Form.Field>
        )}

        {isEnabled && <Map useGeocodePayload={useGeocodePayload} />}

        {/*
         // @ts-expect-error TS2322 */}
        <Form.Row marginTop={isEnabled || editing ? 'large' : 0}>
          <Form.Field label="Latitude">
            <input
              disabled
              name="latitude"
              type="text"
              // @ts-expect-error TS2322
              value={latitude}
            />
          </Form.Field>

          {/*
           // @ts-expect-error TS2322 */}
          <Form.Field label="Longitude" marginTop={['large', 0]}>
            <input
              disabled
              name="longitude"
              type="text"
              // @ts-expect-error TS2322
              value={longitude}
            />
          </Form.Field>
        </Form.Row>
      </Form>

      {editing && (
        <DashboardModule.Footer>
          <Form.Row>
            <Button
              buttonStyle="secondaryUtility"
              onClick={() => setGeocodeState({ editing: false })}
              size="medium"
            >
              Cancel
            </Button>

            <Button
              buttonStyle="primaryCreate"
              disabled={!saveEnabled}
              loading={updating}
              marginTop={['medium', 0]}
              onClick={() => updateCampaign(updateCampaignPayload)}
              size="medium"
            >
              Save
            </Button>
          </Form.Row>
        </DashboardModule.Footer>
      )}
    </DashboardModule>
  )
}

export default PropertyLocation
